import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogBody,
  DialogFooter,
  DialogTitle,
  DialogDescription,
} from 'src/components/ui/dialog';
import { Button } from 'src/components/ui/button';

// Built on the same Dialog primitive as every other modal in the app
// (rounded-[14px] shell, bordered header with its own close X, brand-tinted
// footer) — this used to wrap the plain shadcn AlertDialog instead, which
// gave every confirm prompt (Submit Candidates, Confirm Delete, Approve
// Work Order, …) a visibly different look from the rest of the app's
// modals: a flat sm:rounded-lg card, a bare black/80 overlay, no close
// button, and unstyled title/footer. Same prop API as before, so none of
// this component's ~10 call sites needed to change.
export function Alert({
  isOpen,
  onClose,
  title,
  description,
  actionText, // Default action text
  cancelText, // Custom cancel button text
  continueText, // Custom continue button text
  onCancel, // Function to call on cancel
  onContinue, // Function to call on continue
  customContent, // Custom content to display between description and footer
}) {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-[460px]">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <DialogBody>
          {description && <DialogDescription>{description}</DialogDescription>}
          {customContent && (
            <div className={description ? 'mt-4' : undefined}>
              {customContent}
            </div>
          )}
        </DialogBody>
        <DialogFooter>
          {cancelText && onCancel && (
            <Button
              type="button"
              variant="outline"
              onClick={() => {
                onCancel();
                onClose();
              }}
            >
              {cancelText}
            </Button>
          )}
          {continueText && onContinue && (
            <Button
              type="button"
              onClick={() => {
                onContinue();
                onClose();
              }}
            >
              {continueText}
            </Button>
          )}
          {!cancelText && !continueText && (
            <Button type="button" onClick={onClose}>
              {actionText}
            </Button>
          )}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
